<template>
  <div
    ref="fulLoader"
    class="full-loader"
    style="display: none;"
  >
    <div
      ref="backdrop"
      class="fade modal-backdrop"
      style="display: none;"
    ></div>
    <switch-page-loader></switch-page-loader>
  </div>
</template>

<script>
  import dModalFullLoader from "@dialogs/modalFullLoader";
  import SwitchPageLoader from "@custom/comp/switchPageLoader";
import { bus } from "@store/dau";
  export default {
      mixins: [dModalFullLoader],
  data(){
      return {
          data: {},
          canStop:true
      }
  },
  components: {SwitchPageLoader},
  created() {
    

    //Force loading animation
    bus.$on("open", e => {
      this.canStop = false;
      this.open({});
    });
    bus.$on("close", e => {
      this.canStop = true;
      this.close();
      
    });
  },
    methods: {
        close() {
          if(this.canStop) {
            document.body.classList.remove("modal-open")
            if(this.$refs.backdrop)
                this.$refs.backdrop.classList.remove("show");

            setTimeout(() => {
                if(this.$refs.backdrop)
                    this.$refs.backdrop.style.display = 'none';
                if(this.$refs.fulLoader)
                    this.$refs.fulLoader.style.display = 'none';
            },150);
            return this;
          }
        },
        open(data) {
            this.data = data;

            document.body.classList.add("modal-open");
            if(this.$refs.backdrop)
                this.$refs.backdrop.style.display = 'block';

            if(this.$refs.fulLoader)
                this.$refs.fulLoader.style.display = 'block';

            setTimeout(() => {
                if(this.$refs.backdrop)
                    this.$refs.backdrop.classList.add("show");
            },0);
            // Return object to handle event in one line
            return this;
        }
      }
}
</script>

<style scoped lang="scss">
  .full-loader {
    position: fixed;
    top: 130px;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 10000;

    > .bigSqr {
      z-index: 1041;
      top: calc(50% - 20px);
      left: calc(50% - 20px);
    }
    > .circle-loader {
      z-index: 1041;
      &.xs {
        top: calc(50% - 20px);
        left: calc(50% - 20px);
      }
      &.sm {
        top: calc(50% - 40px);
        left: calc(50% - 40px);
      }
      &.md {
        top: calc(50% - 60px);
        left: calc(50% - 60px);
      }
      &.lg {
        top: calc(50% - 80px);
        left: calc(50% - 80px);
      }
    }

    > .progress-bar {
      max-width: 500px;
      z-index: 1041;
      top: calc(50% - 10px);
      left: calc(50% - 250px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/mepsaws/dialogs/modalFullLoader.vue